export default "__VITE_ASSET__B$7tXlxF__"